import * as React from 'react'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

type Props = { title: string; description: string; formalModelName: string }
export const BetterServiceForLess: React.FC<Props> = ({ description, title, formalModelName }) => (
  <GraySection className="pt-0">
    <Container>
      <div style={{ borderBottom: '1px solid #818b92', paddingBottom: '40px' }}>
        <h2 className="title">{title}</h2>
        <p className="description">{description}</p>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="m-4 md:mr-3">
            <PricingCard
              title={`Average ${formalModelName} Brake Pad Replacement Cost`}
              lowerPrice={379}
              upperPrice={429}
            />
          </div>
          <div className="m-4 md:ml-3">
            <PricingCard
              title={`Average ${formalModelName} Brake Rotor Replacement Cost`}
              lowerPrice={350}
              upperPrice={490}
            />
          </div>
        </div>
        <p className="description text-center pt-5">
          Average prices are just estimates. For accurate pricing, give us a call or submit an online quote request for
          your {formalModelName}.
        </p>
      </div>
    </Container>
  </GraySection>
)

export const PricingCard: React.FC<{
  lowerPrice: number
  upperPrice: number
  title: string
}> = ({ title, lowerPrice, upperPrice }) => {
  return (
    <div
      className="flex flex-col flex-grow py-8 text-center"
      style={{
        backgroundColor: 'white',
        boxShadow:
          '0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)',
      }}
    >
      <p style={{ color: '#818b92', fontSize: 16 }}>{title}</p>
      <p style={{ fontSize: 50, fontWeight: 700, color: '#565555' }}>
        ${lowerPrice}-${upperPrice}
      </p>
      <p style={{ color: '#818b92', fontSize: 16 }}>Includes Parts, Labor & Warranty</p>
    </div>
  )
}
